import React, { useEffect } from 'react';
import yes from './QuestionStep/assets/vi.png'
import no from './QuestionStep/assets/x1.png'
import { useLocalize } from 'localize-react';

export default function YesOrNoQuestion({ onYesClick, onNoClick }) {

    const { translate } = useLocalize()

    useEffect(() => {
        var tmp = document.createElement("input");
        document.body.appendChild(tmp);
        tmp.focus();
        document.body.removeChild(tmp);
      }, []);

    return (
        <>
            <button onClick={onYesClick} className="option1" type="button">
                <img width="40px" src={yes} alt="" />
                <div>{translate('Yes')}</div>
            </button>
            <button onClick={onNoClick} className="option2" type="button">
                <img width="40px" src={no} alt="" />
                <div>{translate('No')}</div>
            </button>
        </>
    )
}
